/*
 *
 * OperationCurrency
 *
 * @version 1.0.0
 * @author Andrea Esposito
 * @since 26-May-2026
 */

import OperationCurrency from './OperationCurrencyContainer'

export default OperationCurrency
